module.exports = __webpack_public_path__ + "static/img/jiahao.a2a6cd5c.png";